import React from 'react';
import { Link } from 'react-router-dom';
import { LogoIcon } from '../components/Logo';

export default function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="card w-full max-w-md p-8 text-center">
        <div className="flex justify-center">
          <LogoIcon variant="bars" size={40} theme="dark" />
        </div>
        <h1 className="mt-6 text-2xl font-bold text-gray-900">Page not found</h1>
        <p className="mt-2 text-sm text-gray-500">
          That page doesn't exist — it may have moved, or the link you followed is out of date.
        </p>
        <Link to="/home" className="btn-primary mt-6 inline-block">
          Back to your home page
        </Link>
      </div>
    </main>
  );
}
